import {$generateHtmlFromNodes, $generateNodesFromDOM} from '@lexical/html';
import {$getRoot, $createParagraphNode, $isElementNode, $isDecoratorNode, CLEAR_HISTORY_COMMAND} from 'lexical';
import {DOC_STYLE} from '../constants';
import {DEFAULT_TEMPLATE_BODY} from '../defaultTemplate';
import {sanitize} from './sanitize';
import {$createPageNode, $isPageNode} from '../nodes/PageNode.jsx';
import {$ensureStructure} from './structure';

export const stripStyle = (html) => String(html || '').replace(/<style[\s\S]*?<\/style>/gi, '').trim();

/** {{ name }} -> {{name}} */
export const normalizeTokens = (html) =>
  html.replace(/\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g, '{{$1}}');

/** Final document string = regenerated <style> + body. */
export const buildDocument = (body, logoSrc) => {
  const css = logoSrc ? DOC_STYLE.replace(/\{\{logo\}\}/g, () => logoSrc) : DOC_STYLE;
  return `<style>${css}</style>${body}`;
};

export function exportBodyHtml(editor) {
  let html = '';
  editor.getEditorState().read(() => { html = $generateHtmlFromNodes(editor); });
  return html;
}

/** Editor state -> clean body HTML (sanitized, tidied, tokens normalised). Pure read. */
export function buildOutput(editor) {
  return normalizeTokens(sanitize(exportBodyHtml(editor), 'save'));
}

export function loadHtmlIntoEditor(editor, html) {
  const source = String(html || '').trim() ? html : DEFAULT_TEMPLATE_BODY;
  const clean = sanitize(normalizeTokens(stripStyle(source)), 'load');
  editor.update(
    () => {
      const root = $getRoot();
      root.clear();
      const dom = new DOMParser().parseFromString(`<body>${clean}</body>`, 'text/html');
      const nodes = $generateNodesFromDOM(editor, dom);
      let page = null;
      nodes.forEach((n) => {
        if ($isPageNode(n)) {
          root.append(n);
          page = null;
          return;
        }
        if (!page) { page = $createPageNode(); root.append(page); }
        if ($isElementNode(n) && !n.isInline()) page.append(n);
        else if ($isDecoratorNode(n) && !n.isInline()) page.append(n);
        else { const p = $createParagraphNode(); p.append(n); page.append(p); }
      });
      $ensureStructure();
    },
    {discrete: true}
  );
  editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
}
